import { KeyValuePipe, NgFor, NgIf } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  Input,
} from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  CodecraftAnswer,
  CodecraftQuestion,
} from '@codecraft-works/data-models';
import { ShufflePipe } from '../util/shuffle.pipe';

@Component({
  standalone: true,
  selector: 'codecraft-quiz-multiple-answer-question',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <fieldset
      *ngIf="questionForm && question"
      [formGroup]="questionForm"
      class="form-group"
    >
      <p>
        {{ question.prompt }}
      </p>
      <div *ngFor="let choice of question.choices | keyvalue | shuffle">
        <label>
          <input
            [id]="'question_' + choice.key"
            [formControlName]="choice.key"
            type="checkbox"
            [name]="'question_' + choice.key"
            [value]="choice.value"
          />
          {{ choice.value }}
          <ng-container *ngIf="correctQuestionData">
            <ng-container
              *ngIf="correctQuestionData.correctAnswer[choice.key] === true"
              ><span class="badge badge-success">Correct choice!</span>
            </ng-container>
            <ng-container
              *ngIf="
                !correctQuestionData.isCorrect &&
                correctQuestionData.correctAnswer[choice.key] === false &&
                questionForm.controls[choice.key].value === true
              "
              ><span class="badge badge-danger">Incorrect choice!</span>
            </ng-container>
          </ng-container>
        </label>
      </div>
    </fieldset>

    <div
      class="alert alert-success"
      *ngIf="correctQuestionData && correctQuestionData.isCorrect"
    >
      Correct Answer!
    </div>
    <div
      class="alert alert-danger"
      *ngIf="correctQuestionData && !correctQuestionData.isCorrect"
    >
      Incorrect Answer!
    </div>
  `,
  styles: [
    `
      div.alert {
        color: white;
        max-width: fit-content;
      }
    `,
  ],
  imports: [NgIf, NgFor, ReactiveFormsModule, KeyValuePipe, ShufflePipe],
})
export class CodecraftQuizMultipleAnswerQuestionComponent
  implements AfterViewInit
{
  @Input() question: CodecraftQuestion | undefined;
  @Input() questionForm: FormGroup | undefined;
  @Input() correctQuestionData:
    | {
        isCorrect: boolean;
        correctAnswer: CodecraftAnswer;
      }
    | undefined;
  @Input() answerGiven: CodecraftAnswer | undefined;

  ngAfterViewInit(): void {
    if (this.question?.choices instanceof Map) {
      this.question.choices.forEach((_value, key) => {
        const input = document.getElementById(
          `question_${key}`
        ) as HTMLInputElement;
        input.readOnly = true;
        const userAnswer =
          this.answerGiven instanceof Map
            ? this.answerGiven.get(key)
            : this.answerGiven?.[key] || false;
        if (userAnswer === input.value) {
          input.checked = true;
        }
      });
    }
  }
}
